// extracted by mini-css-extract-plugin
export var infoRow = "_ss-2";
export var labelContainer = "_ss-0";
export var rightInfo = "_ss-1";